import React from 'react';
import { mergeStyles, Stack, Text } from '@fluentui/react';
import { p4Tokens } from '../../styles/themes/default/p4FluentTheme';
import { CheckmarkCircle24Filled } from '@fluentui/react-icons';
import { IAssemblyWithReceipt } from '../../graphql/schema/p4types';

const containerStyles = (isSelected: boolean) =>
  mergeStyles({
    width: '100%',
    backgroundColor: isSelected ? '#dbecfa' : 'transparent',
    borderTop: !isSelected ? `1px solid ${p4Tokens.colorHeaderBackground}` : 'none',
    borderBottom: !isSelected ? `1px solid ${p4Tokens.colorHeaderBackground}` : 'none',
    transition: 'background-color 0.2s ease',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: isSelected ? '#dbecfa' : p4Tokens.colorHeaderBackground,
    },
  });

const textPanelStyles = () =>
  mergeStyles({
    margin: '10px',
    width: '100%',
  });

const statusIconStyles = (processed: boolean) =>
  mergeStyles({
    fontSize: '16px',
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: processed ? p4Tokens.statusFlagSuccess : p4Tokens.statusFlagBasic,
    opacity: processed ? 1 : 0.75,
  });

const readIndicatorStyles = (isSelected: boolean, visited: boolean, processed: boolean) =>
  mergeStyles({
    backgroundColor: visited ? 'transparent' : processed ? p4Tokens.statusFlagSuccess : p4Tokens.statusFlagBasic,
    width: '5px',
    transition: 'width 0.2s ease, background-color 0.2s ease',
    cursor: 'pointer',
    '.list-item-container:hover &:not(:hover)': {
      backgroundColor: processed ? p4Tokens.statusFlagSuccess : p4Tokens.statusFlagBasic,
      opacity: isSelected ? 1.0 : 0.5,
      width: '5px',
    },
    ':hover': {
      backgroundColor: processed ? p4Tokens.statusFlagSuccess : p4Tokens.statusFlagBasic,
      width: '10px',
      opacity: isSelected ? 1.0 : 0.5,
    },
  });

const textStyles = (visited: boolean) =>
  mergeStyles({
    fontWeight: visited ? 'normal' : 'bold',
    fontSize: 'medium',
  });

const AssemblyListItem = ({
  assemblyWithReceipt,
  processed,
  visited,
  isSelected,
  onReadIndicatorClick,
}: {
  assemblyWithReceipt: IAssemblyWithReceipt;
  processed: boolean;
  visited: boolean;
  isSelected: boolean;
  onReadIndicatorClick?: (event: React.MouseEvent) => void;
}) => {
  return (
    <Stack horizontal className={`${containerStyles(isSelected)} list-item-container`}>
      <div
        className={`${readIndicatorStyles(isSelected, visited, processed)} read-indicator`}
        onClick={(event) => onReadIndicatorClick?.(event)}
      />
      <Stack className={textPanelStyles()}>
        <Stack horizontal verticalAlign="center" horizontalAlign="space-between" tokens={{ childrenGap: 12 }}>
          <Text className={textStyles(visited)}>{assemblyWithReceipt?.assembly?.product?.reference}</Text>
          <div className={statusIconStyles(processed)}>
            <CheckmarkCircle24Filled />
          </div>
        </Stack>
        <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 12 }}>
          <Text>
            <small>{`Order Number: ${assemblyWithReceipt?.assembly?.orderNumber}`}</small>
          </Text>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default AssemblyListItem;
